// extracted by mini-css-extract-plugin
export default {"tabs":"tabs___jwPQll2v","tabs__list":"tabs__list___JViZO6E9","tabs__trigger":"tabs__trigger___B58LTsae","tabs__content":"tabs__content___lxkrqww7"};